import { KdActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const KdReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case KdActionType.Kd_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default KdReducer
